module.exports = __webpack_public_path__ + "img/parter-logo-1.c2ccbbae.jpg";